import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/typing-test'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.TypingTestPageProps>()(Page.TypingTest)
